/**
 * Labstep
 *
 * @module state/services/schema
 * @desc Combine all redux actions using normalizr
 */

// biome-ignore lint/style/noExportedImports: Old redux layer
import * as schema from './schema';

export default schema;
